import { getContainingComponent } from "ceres/app/helper/utils";
import { Swiper } from 'swiper';

const browserDetect = require("detect-browser");
const NotificationService = require("ceres/app/services/NotificationService");
const AutoFocusService = require("ceres/app/services/AutoFocusService");

import Vue from "vue";
import { getStyle } from "ceres/app/helper/dom";
import { detectPassiveEvents } from "ceres/app/helper/featureDetect";
import HeaderScroller from "ceres/app/helper/HeaderScroller";

// Frontend end scripts
// eslint-disable-next-line
const headerCollapses = [];

function HeaderCollapse(selector)
{
    headerCollapses.push(selector);
    $(function()
    {
        $(selector).on("show.bs.collapse", () =>
        {
            headerCollapses.forEach(element =>
            {
                if (!$(element).is(selector))
                {
                    $(element).collapse("hide");
                }
            });
        });

    });
}

function CeresMain()
{
    const browser = browserDetect.detect();

    if (browser)
    {
        if (browser.name)
        {
            $("html").addClass(browser.name);
        }
        else
        {
            $("html").addClass("unknown-browser");
        }
        if (browser.os)
        {
            $("html").addClass(browser.os.toLowerCase().replace(/[^a-zA-Z0-9\-]/g, "-").replace("windows", "windows windows"));
        }
        else
        {
            $("html").addClass("unknown-os");
        }
    }
    else
    {
        $("html").addClass("unknown-detect");
    }

    window.onpopstate = function(event)
    {
        if (event.state && event.state.requireReload)
        {
            window.location.reload();
        }
    };

    // init bootstrap tooltips
    document.querySelectorAll("[data-toggle=\"tooltip\"]").forEach(el =>
    {
        $(el).tooltip();
    });

    HeaderCollapse("#shippingSelect");
    HeaderCollapse("#currencySelect");
    HeaderCollapse("#searchBox");

    const $mainNavbarCollapse = $("#mainNavbarCollapse");

    // prevent hidding collapses in the shopbuilder, for editing search bar results
    if (!App.isShopBuilder)
    {
        $(document).on("click", function(evt)
        {
            headerCollapses.forEach(element =>
            {
                if (evt.target !== element && $(evt.target).parents(element).length <= 0)
                {
                    $(element).collapse("hide");
                }
            });
        });
    }

    $mainNavbarCollapse.collapse("hide");

    // Add click listener outside the navigation to close it
    $mainNavbarCollapse.on("show.bs.collapse", function()
    {
        $(".main").one("click", closeNav);
    });

    $mainNavbarCollapse.on("hide.bs.collapse", function()
    {
        $(".main").off("click", closeNav);
    });

    function closeNav()
    {
        $("#mainNavbarCollapse").collapse("hide");
    }

    $(function()
    {
        var vueAppEl = document.getElementById("vue-app");
        var pageHeaderEl = document.getElementById("page-header");

        if ( !!vueAppEl && !!pageHeaderEl )
        {
            vueAppEl.style.marginTop = pageHeaderEl.getBoundingClientRect().height + 'px';
        }

        const offset = 250;
        const duration = 300;

        vueApp.$store.commit("setViewPortSize", window.innerWidth);

        window.addEventListener("resize", function()
        {
            isDesktop = window.matchMedia("(min-width: 768px)").matches;
            // Weitere Commits bei Resize:
            vueApp.$store.commit("setViewPortSize", window.innerWidth);
        });

        let isDesktop = window.matchMedia("(min-width: 768px)").matches;

        AutoFocusService.autoFocus();

        $("#searchBox").on("shown.bs.collapse", function()
        {
            const searchInput = document.querySelector("input.search-input");

            if (searchInput)
            {
                searchInput.focus();
            }
        });

        window.addEventListener("scroll", function()
        {
            if (isDesktop)
            {
                if ($(window).scrollTop() > offset)
                {
                    $(".back-to-top").fadeIn(duration);
                    $(".back-to-top-center").fadeIn(duration);
                }
                else
                {
                    $(".back-to-top").fadeOut(duration);
                    $(".back-to-top-center").fadeOut(duration);
                }
            }
        }, detectPassiveEvents() ? { passive: true } : false );

        window.addEventListener("resize", function()
        {
            isDesktop = window.matchMedia("(min-width: 768px)").matches;
        });

        $(".back-to-top").on("click", function(event)
        {
            event.preventDefault();

            $("html, body").animate({ scrollTop: 0 }, duration);

            return false;
        });

        $('.close-message').click(function(){
            $('.header-message').addClass('d-none');
        });

        $(".back-to-top-center").on("click", function(event)
        {
            event.preventDefault();

            $("html, body").animate({ scrollTop: 0 }, duration);

            return false;
        });

        $("#accountMenuList").on("click", function()
        {
            $("#shippingSelect").collapse("hide");
            $("#searchBox").collapse("hide");
            $("#currencySelect").collapse("hide");
        });

        $(".ddown").on("keydown", function(event)
        {
            if (event.key === "Space" || event.keyCode === 32)
            {
                event.preventDefault();
                const li = this.closest("li");

                const isOpen = li.classList.toggle("hover");

                this.setAttribute("aria-expanded", isOpen);
            }
        });

        fixPopperZIndexes();

        // Emit event for Sticky Containers to update
        $(".collapse").on("show.bs.collapse hide.bs.collapse", function()
        {
            this.dispatchEvent(new CustomEvent("updateStickyContainer",
                {
                    bubbles: true
                }));
        });

        if(window.location.search.indexOf("page=")> -1 && App.templateEvent === "tpl.category.item"){
            window.scrollTo(0,0);
        }

        $('[data-toggle-second="tooltip"]').tooltip();


        $('.dia-controls-list__item').on('show.bs.dropdown', function () {
            $('[data-toggle-second="tooltip"]').tooltip('hide');
        });

        $('#basket-toggle').on('click', function () {
            $('[data-toggle-second="tooltip"]').tooltip('hide');
        });

        new Swiper('#js--swiper__top-bar', {
            spaceBetween  : 0,
            slidesPerView : 1,
            loop: true,
            autoplay: {
                delay: 5000,
            },
            navigation: {
                nextEl: '.header__top-wrapper .swiper-button-next',
                prevEl: '.header__top-wrapper .swiper-button-prev',
            },
            breakpoints: {
                992: {
                    slidesPerView: 3
                }
            }
        })

        new Swiper('.swiper-container--brands', {
            spaceBetween  : 0,
            autoHeight    : false,
            slidesPerView : 3.5,
            freeMode      : true,
            allowTouchMove: true,
            breakpoints: {
                576: {
                    slidesPerView : 5.5,
                },
                768: {
                    slidesPerView : 6.5,
                    spaceBetween  : 24,
                },
                992: {
                    spaceBetween  : 0,
                    slidesPerView : 8,
                    cssMode       : false,
                    allowTouchMove: false
                }
            },
            navigation: {
                nextEl: '.swiper-button-next--brands',
                prevEl: '.swiper-button-prev--brands'
            }
        });

        if(sessionStorage.getItem('trustamiclosed') !== null){
            $('body').addClass("trustami-closed");
        }

        $(document).on("click", "#taCloseBtnOverlay", function(){
            sessionStorage.setItem('trustamiclosed', 'true');
        });
    });

    $(document).ready(function() {
        $("#js--list-sort-hidden-option").html($('#js--list-sort option:selected').text());
        $("#js--list-sort").width($("#js--list-sort-hidden").width() - 13);
    });
}

window.CeresMain = new CeresMain();
window.CeresNotification = NotificationService;

const showShopNotification = function(event)
{
    if (event.detail.type)
    {
        switch (event.detail.type)
        {
        case "info":
            NotificationService.info(event.detail.message);
            break;
        case "log":
            NotificationService.log(event.detail.message);
            break;
        case "error":
            NotificationService.error(event.detail.message);
            break;
        case "success":
            NotificationService.success(event.detail.message);
            break;
        case "warning":
            NotificationService.warn(event.detail.message);
            break;
        default:
            console.log("no type such as:" + event.detail.type);
            break;
        }
    }
};

document.addEventListener("showShopNotification", showShopNotification);

// fixate the header elements
new HeaderScroller();

$(document).on("shopbuilder.after.drop shopbuilder.after.widget_replace", function(event, eventData, widgetElement)
{
    const parent = widgetElement[1];

    const parentComponent = getContainingComponent(parent);

    const compiled = Vue.compile(widgetElement[0].outerHTML, { delimiters: ["${", "}"] } );
    const component = new Vue({
        store: window.ceresStore,
        render: compiled.render,
        staticRenderFns: compiled.staticRenderFns,
        parent: parentComponent
    });

    component.$mount( widgetElement[0] );
    $(component.$el).find("*").each(function(index, elem)
    {
        $(elem).on("click", function(event)
        {
            event.preventDefault();
        });
    });

    $(component.$el).find(".owl-carousel").on("resized.owl.carousel", function()
    {
        window.dispatchEvent(new Event("resize"));
    });
});

function fixPopperZIndexes()
{
    const elements = document.querySelectorAll(".popover.d-none");

    let counter = elements.length;

    elements.forEach(el =>
    {
        let zIndex = parseInt(getStyle(el, "z-index"));

        if (!isNaN(zIndex))
        {
            zIndex += --counter;

            el.style.zIndex = zIndex;
        }
    });
}
